// Utilidades para captura de UTM e formato de WhatsApp
export type UtmData = {
  pageUrl: string;
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmContent: string;
  utmTerm: string;
};

export const captureUtm = (): UtmData => {
  if (typeof window === "undefined") {
    return { pageUrl: "", utmSource: "", utmMedium: "", utmCampaign: "", utmContent: "", utmTerm: "" };
  }
  const p = new URLSearchParams(window.location.search);
  return {
    pageUrl: window.location.href,
    utmSource: p.get("utm_source") || "",
    utmMedium: p.get("utm_medium") || "",
    utmCampaign: p.get("utm_campaign") || "",
    utmContent: p.get("utm_content") || "",
    utmTerm: p.get("utm_term") || "",
  };
};

export const buildWhatsAppLink = (rawNumber: string, message?: string): string => {
  let digits = (rawNumber || "").replace(/\D/g, "");
  if (!digits.startsWith("55")) digits = "55" + digits;
  const msg = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${digits}${msg}`;
};
